// extracted by mini-css-extract-plugin
export var addToCartWrapper = "_w3-8";
export var editMode = "_w3-3";
export var headerRow = "_w3-a";
export var headerTitle = "_w3-b";
export var product = "_w3-1";
export var productDetails = "_w3-5";
export var productDivider = "_w3-7";
export var productImage = "_w3-2";
export var productInfo = "_w3-4";
export var productTitle = "_w3-6";
export var strikethrough = "_w3-9";
export var upsellProductsCard = "_w3-0";